import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSubscriptionsBySessionId } from '@guryou/redux';

import { resetState } from '../actions';
import { SUBSCRIPTIONS_CANCEL, SUBSCRIPTIONS_CREATE, SUBSCRIPTIONS_GET_MANY, SUBSCRIPTIONS_UPDATE } from '../new';

import { useEffectOnSuccess } from '.';

const useSubscriptionsBySession = sessionId => {
  const dispatch = useDispatch();
  const subscriptionsBySession = useSelector(state => state.subscriptions.active);

  useEffect(() => {
    dispatch(getSubscriptionsBySessionId(sessionId));
  }, [dispatch, sessionId]);

  useEffectOnSuccess([state => state.subscriptions.create, state => state.subscriptions.update, state => state.subscriptions.cancel], () => {
    dispatch(getSubscriptionsBySessionId(sessionId));
    dispatch(resetState(SUBSCRIPTIONS_GET_MANY));
    dispatch(resetState(SUBSCRIPTIONS_CREATE));
    dispatch(resetState(SUBSCRIPTIONS_UPDATE));
    dispatch(resetState(SUBSCRIPTIONS_CANCEL));
  });

  return subscriptionsBySession;
};

export default useSubscriptionsBySession;
